import React, { Component } from "react";
import Context from "../../../context/Context";
import Topic from "../../../context/Topic";
import * as CrudReply from "../../base/transaction/reply";
import * as commentReplyUtil from "./commentReplyUtil";
import Button from "../../../common/components/Button";
import { ButtonGroup } from "../../styles/Common/sort";
import TextareaAutosize from 'react-textarea-autosize';
import { ButtonGroupInput } from "../../styles/commentsStyles";
import  { ThemeColorButton, ReplyWrapper } from "../../styles/commentsStyles";


export default class InputReply extends Component {

    constructor(props){
        super(props);
        this.state={
            inputChange : '',
            emptyReply: false
        }
    }

    handleSave = () => {
        const reply = this.state.inputChange;
        const author = Context.instance.user.getUsername();
        const openPlanId = Context.instance.spaceplanner.planId;
        const commentId = this.props.id;
        const geometry = this.props.geometry;
        let obj;
        if(!this.state.inputChange) {
            this.setState({
                emptyReply : true
            })
        }else{
            if(geometry) {
                obj = {
                  reply: reply,
                  author: author,
                  planId: openPlanId,
                  commentId: commentId,
                  geometry: geometry
                }
              }else{
                obj = {
                  reply: reply,
                  author: author,
                  planId: openPlanId,
                  commentId: commentId
                }
              }
              const url = commentReplyUtil.getCommentUrl();
              CrudReply.addReply(obj, url).then((resp)=>{
                  Topic.publish(Topic.LoadComments, {});
                  this.props.closeReply();
                  this.props.changeMode("expandComment");
              })
              .catch(error=>{
                console.error(error);
                Topic.publishErrorUpdatingData(error.message);
              })
        }
      }

    handleInputChange =(evt)=> {
        this.setState({
            inputChange : evt.target.value
        },function(){
            if(!this.state.inputChange) {
                this.setState({
                    emptyReply : true
                })
            }else{
                this.setState({
                    emptyReply : false
                })
            }
        })
    }

    handleCancel=()=>{
        this.props.closeReply();
    }

    render(){
        const i18n = Context.instance.i18n;
        let showError;
        if(this.state.emptyReply) showError = i18n.spaceplanner.reply.emptyReply;
        if(this.props.reply==="reply"){
            return  (
                    <div style={{display:"flex", flexDirection: "column", flexShrink:0,  alignItems: "flex-end", background:"#fff", margin: "0.5rem", border:"1px solid #cacaca", padding:"0.5rem"}}>
                        <TextareaAutosize 
                            autoFocus
                            value={Context.sanitizeHtml(this.state.inputChange)}
                            style={{width:"97%", borderColor:"#cacaca", padding:"5px", fontFamily: "sans-serif", color:"#323232",}} minRows={2} onChange={this.handleInputChange}/>
                        <div style={{fontSize: "0.8125rem", color: "#808080"}}>{showError}</div>
                        <ButtonGroup>
                            <ThemeColorButton onClick={this.handleSave}>{i18n.general.save}</ThemeColorButton>
                            <ThemeColorButton onClick={this.handleCancel}>{i18n.general.cancel}</ThemeColorButton>
                        </ButtonGroup>
                    </div>
                )
        }else{
            return  (
                <ReplyWrapper>
                    <div style={{display:"flex", flexDirection: "column", flexShrink:0,  alignItems: "flex-end", background:"#fff", margin: "0.5rem", border:"1px solid #cacaca", padding:"0.5rem"}}>
                        <TextareaAutosize 
                            autoFocus
                            value={Context.sanitizeHtml(this.state.inputChange)}
                            style={{width:"97%", borderColor:"#cacaca", padding:"5px", fontFamily: "sans-serif", color:"#323232",}} minRows={2} onChange={this.handleInputChange}/>
                        <div style={{fontSize: "0.8125rem", color: "#808080"}}>{showError}</div>
                        <ButtonGroup>
                            <ThemeColorButton onClick={this.handleSave}>{i18n.general.save}</ThemeColorButton>
                            <ThemeColorButton onClick={this.handleCancel}>{i18n.general.cancel}</ThemeColorButton>
                        </ButtonGroup>
                    </div>
                </ReplyWrapper>
            )

        }

    }
}